import { Suspense } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import CategoriesStrip from "@/components/CategoriesStrip";

const VideoSection = lazyWithRetry(() => import("@/components/VideoSection"));
const GallerySection = lazyWithRetry(() => import("@/components/GallerySection"));
const HistorySection = lazyWithRetry(() => import("@/components/HistorySection"));
const ValuesSection = lazyWithRetry(() => import("@/components/ValuesSection"));
const TestimonialsSection = lazyWithRetry(() => import("@/components/TestimonialsSection"));
const ContactSection = lazyWithRetry(() => import("@/components/ContactSection"));
const Footer = lazyWithRetry(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[200] focus:top-4 focus:left-4 focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:text-sm">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <CategoriesStrip />
        <Suspense fallback={<div className="min-h-screen" />}>
          <GallerySection />
          <HistorySection />
          <ValuesSection />
          <VideoSection />
          <TestimonialsSection />
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
